/////////////////////////
// VALIDATION PATTERNS 
/////////////////////////

var regex = "^[a-zA-Z]+[a-zA-Z0-9-_ ]*[a-zA-Z0-9]$";
var emailRegex = "^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$";
var addressRegex = "[\w \d \s \.]";
var phoneRegex = "/^((([0-9]{1})*[- .(]*([0-9]{3})[- .)]*[0-9]{3}[- .]*[0-9]{4})+)*$/";
var zipRegex = "[0-9]{5}";
var nameRegex = ".+";
var ssnRegex = "^(\\d{3}-?\\d{2}-?\\d{4}|XXX-XX-XXXX)$";
var dateRegex = "^(0[1-9]|1[012])[/](0[1-9]|[12][0-9]|3[01])[/](19|20)\\d\\d$";
var currencyRegex = "^[0-9,.$]+$";
var yearRegex = "(0*(?:[0-9][0-9]?|100))";
var monthRegex = "^([0-9]|1[011])$";
var creditCardRegex = "^[0-9][0-9]{12,18}$"

export {
    regex,
    emailRegex,
    addressRegex,
    phoneRegex,
    zipRegex,
    nameRegex,
    ssnRegex,
    dateRegex,
    currencyRegex,
    yearRegex,
    monthRegex,
    creditCardRegex
}